import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '@app/core/business/user/authentication.service';

@Injectable()
export class AuthGuardService  {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.authenticationService.isConnected$.pipe(
      map(isLoggedIn => {
        if (!this.authenticationService.checkConnection() && !location.pathname.includes('login')) {
          this.router.navigateByUrl('login');
        } else {
          return this.authenticationService.checkConnection();
        }
      })
    );
  }
}
